import React from 'react';

import { useLocalize } from '../../../hooks/useLocalize';
import { ListModal } from '../../listModal/ListModal';
import { ILanguageOption } from '../../localization/LanguageContext';
import { LanguageProps } from '../Language';
import { SearchLanguageItem } from '../searchLanguageItem/SearchLanguageItem';

interface LanguageModalMobileProps {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  languagesList: LanguageProps[];
  suggestedLanguageList: LanguageProps[];
  currentLanguage: ILanguageOption | undefined;
  onLanguageChange: (lng: string) => void;
}
export function LanguageModalMobile({
  modalOpen, setModalOpen, languagesList, suggestedLanguageList, currentLanguage, onLanguageChange,
}: LanguageModalMobileProps) {
  const { translate: t } = useLocalize();

  return (
    <ListModal
      show={modalOpen}
      modalTitle={t('select_your_language')}
      onClose={() => setModalOpen(false)}
    >
      <div className="modal-list-header">{t('suggested_languages')}</div>
      {suggestedLanguageList.map((languageItem: any) => (
        <SearchLanguageItem
          key={languageItem.key}
          name={languageItem.value}
          icon={languageItem.icon}
          code={languageItem.key}
          selectedItem={currentLanguage?.language_iso_code}
          onClick={() => {
            onLanguageChange(languageItem.key);
            setModalOpen(false);
          }} />
      ))}
      <div className="modal-list-header mt-2">{t('all_languages')}</div>
      {languagesList.map((languageItem: any) => (
        <SearchLanguageItem
          key={languageItem.key}
          name={languageItem.value}
          icon={languageItem.icon}
          code={languageItem.key}
          selectedItem={currentLanguage?.language_iso_code}
          onClick={() => {
            onLanguageChange(languageItem.key);
            setModalOpen(false);
          }} />
      ))}
    </ListModal>
  );
}
